import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import './App.css';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Home from './components/home/Home';
import Portfolio from './components/portfolio/Portfolio';
import Services from './components/services/Services';
import Sidebar from './components/sidebar/Sidebar';

const App = () => {
  useEffect(() => {
    const analyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

    // Google Analytics scriptini yuklash
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
    document.head.appendChild(script);

    // Google Analytics konfiguratsiyasi
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', analyticsId);
  }, []);

  return (
    <>
      <Sidebar />
      <main className="main">
        <Home />
        <About />
        <Portfolio />
        <Services />
        {/* <Resume/> */}
        {/* <Pricing/> */}
        {/* <Blog/> */}
        <Contact />
        <Toaster />
      </main>
    </>
  );
};

export default App;
